import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, IconButton, Typography } from '@mui/material';
import { TP_COLORS } from '../../../../constants';
import AccountDeleteModal from './AccountDeleteModal';

const MenuButton: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isAccountDeleteModalOpen, setAccountDeleteModalOpen] = useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    setAccountDeleteModalOpen(true);
    setAnchorEl(null);
  };

  return (
    <Box position="absolute" top="25px" right="25px">
      <IconButton
        sx={{ padding: '5px', backgroundColor: '#F8FAFC1A' }}
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MoreHorizIcon
          sx={{ color: '#F8FAFC', width: '30px', height: '28px' }}
        />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleDelete} sx={{ color: TP_COLORS.orange.light }}>
          <DeleteOutlineIcon fontSize="small" />
          <Typography fontSize="14px" marginLeft="5px">
            Delete Account
          </Typography>
        </MenuItem>
      </Menu>
      {isAccountDeleteModalOpen && (
        <AccountDeleteModal
          open={isAccountDeleteModalOpen}
          onClose={() => setAccountDeleteModalOpen(false)}
        />
      )}
    </Box>
  );
};

export default MenuButton;
